// Modificada por IAL | 2026-04-10 | Powered by ianossolutions.ai
import { Component, OnInit, ViewChild, ElementRef, Inject, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from "../../../services/auth.service";
import Swal from 'sweetalert2';
import { HttpService } from "../../../services/http.service";
import { environment } from "../../../../environments/environment";
import { User } from "../../../shared/user";
import { RolesService } from "../../../services/roles.service";
import { CommonService } from "../../../services/common.service";
import { EventsService } from "../../../services/events.service";
import { forkJoin, Subscription } from "rxjs";
import { FirestoreService } from "../../../services/firestore.service";
import { NotificationSoundService } from "../../../services/notification-sound.service";
import { DataSharingService } from "../../../services/data-sharing.service";
import { TranslateService } from '@ngx-translate/core';
import { CommunicationService } from 'src/app/services/communication.service';

declare var google: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

  newOrders: any[] = [];
  currency: string = environment.currency;
  public user: User;

  collectionName2 = 'Orders';
  collectionField2 = 'order_createday';
  orderByDir2: any = 'desc';
  orders: Subscription;
  private routerSubscription: Subscription;
  private alertSoundSubscription: Subscription;
  private adminCommerceSubscription: Subscription;

  tableReservationsList: any[] = [];
  tables: any[] = [];
  private tableReservationsSubscription: Subscription;
  private tablesSubscription: Subscription;

  private alert_new_order_sound: boolean = localStorage.getItem('alert_new_order_sound') == 'true' || false;
  admin_commerce: string = "";
  adminCommerceData: any = {};
  languageSelected: string = environment.default_language;
  public logo: string = environment.logo;

  // ✅ VARIABLES PARA CONTROLAR EL SONIDO
  private soundPlayed: boolean = false;
  private previousNewOrdersCount: number = 0;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private auth: AuthService,
    private service: HttpService,
    private rolesService: RolesService,
    private commonService: CommonService,
    private events: EventsService,
    private firestore: FirestoreService,
    private notificacionSound: NotificationSoundService,
    private dataSharingService: DataSharingService,
    private translate: TranslateService,
    private communicationService: CommunicationService,
  ) {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.rolesService.verifyRoles().then(value => {
          let url = this.router.url;
          let title = url.substring(url.indexOf('/') + 1);
          let page = title.split('/');
        }).catch(error => {
        });
      }
    });

    this.getLanguage();
  }

  ngOnInit(): void {
    this.service.sendGET_Splashscreen().subscribe(data => {
      this.logo = data.splash_screen_commerce_logo || environment.logo;
    });

    // Cargar usuario desde backend
    this.getUser();

    // Cargar órdenes desde backend con listener de Firestore
    this.getOrdersByStatus();

    // Cargar mesas y reservaciones
    this.getTablesData();
    this.getReservationsData();

    // Configurar evento de sonido de alerta
    document.addEventListener('click', () => {
      this.subscribeAlertSound();
    });
  }

  ngOnDestroy(): void {
    // Limpiar todas las suscripciones
    if (this.orders) this.orders.unsubscribe();
    if (this.routerSubscription) this.routerSubscription.unsubscribe();
    if (this.alertSoundSubscription) this.alertSoundSubscription.unsubscribe();
    if (this.adminCommerceSubscription) this.adminCommerceSubscription.unsubscribe();
    if (this.tableReservationsSubscription) this.tableReservationsSubscription.unsubscribe();
    if (this.tablesSubscription) this.tablesSubscription.unsubscribe();
  }

  googleTranslateElementInit() {
    new google.translate.TranslateElement({
      pageLanguage: 'fr',
      includedLanguages: 'es,ca,eu,gl,en,fr,it,pt,de',
      layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
      gaTrack: true
    }, 'google_translate_element');
  }

  getLanguage() {
    let valor = localStorage.getItem('language_code');
    this.languageSelected = !valor ? environment.default_language : valor;
    this.translate.use(this.languageSelected);
  }

  setLanguage(item) {
    localStorage.setItem('language_code', item);
    this.languageSelected = item;
    this.translate.use(this.languageSelected);
    this.communicationService.triggerComponentRefresh();
  }

  subscribeAlertSound() {
    // Evitar múltiples suscripciones
    if (this.alertSoundSubscription) {
      return;
    }

    // Suscribirse al Observable para recibir los valores actualizados
    this.alertSoundSubscription = this.dataSharingService.alert_new_order_sound.subscribe((valor: boolean | string) => {
      // Actualizar el valor de alert_new_order_sound
      this.alert_new_order_sound = valor == 'true';
      if (valor == 'true') {
        this.playNotification();
      } else {
        this.notificacionSound.stopNotificationSound();
        this.soundPlayed = false;
      }
    });
  }

  playNotification() {
    // ✅ SOLO REPRODUCIR SI HAY ÓRDENES NUEVAS Y NO SE HA REPRODUCIDO YA
    if (this.newOrders.length > 0 && !this.soundPlayed && this.alert_new_order_sound) {
      this.soundPlayed = true;
      this.notificacionSound.requestPermission().subscribe(permission => {
        this.notificacionSound.playNotificationSound();
      });
    }
  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  getOrdersByStatus() {
    // this.orders = this.firestore.search(this.collectionName2, {
    //   'orderByName': this.collectionField2,
    //   'orderByDir': this.orderByDir2,
    // }).subscribe(
    //   res1 => {
    //     forkJoin({
    //       new: this.service.getOrdersByStatus('New'),
    //       programmed: this.service.getOrdersByStatus('Programmed')
    //     }).subscribe({
    //       next: (result) => {
    //         let newOrdersList = result.new?.listing || [];
    //         let programmedOrdersList = result.programmed?.listing || [];
    //         let allOrders = [...newOrdersList, ...programmedOrdersList];
    //         console.log('📥 newOrdersList RAW:', newOrdersList.length, newOrdersList[0]);
    //         console.log('📥 programmedOrdersList RAW:', programmedOrdersList.length, programmedOrdersList[0]);
    //         console.log('📥 allOrders ANTES de filtrar:', allOrders.length);

    //         // ✅ OBTENER EL COMMERCE_UID DEL USUARIO (ASIGNADO EN getUser)
    //         const userCommerceUid = (this.user as any)?.commerce_uid || '';
    //         console.log('🔍 userCommerceUid:', userCommerceUid);

    //         console.log('🔍 userCommerceUid:', userCommerceUid);
    //         if (userCommerceUid) {
    //           // ✅ FILTRAR POR COMMERCE_UID (o business_place_uid como respaldo)
    //           allOrders = allOrders.filter(order =>
    //             order.commerce_uid === userCommerceUid ||
    //             order.business_place_uid === userCommerceUid
    //           );
    //           console.log(`🔔 Filtrado por commerce_uid: ${userCommerceUid} - ${allOrders.length} órdenes totales`);
    //         } else {
    //           console.log(`🔔 Mostrando TODAS las órdenes: ${allOrders.length}`);
    //         }

    //         // ✅ SEPARAR SOLO ÓRDENES "New"
    //         const newOrdersOnly = allOrders.filter(order => order.orders_status_uid === 'New');
    //         const programmedOrders = allOrders.filter(order => order.orders_status_uid === 'Programmed');

    //         const previousCount = this.previousNewOrdersCount;
    //         this.previousNewOrdersCount = newOrdersOnly.length;

    //         const hasNewOrderDetected = newOrdersOnly.length > previousCount;

    //         if (newOrdersOnly.length > 0) {
    //           this.newOrders = newOrdersOnly;
    //           this.dataSharingService.updateOrders(allOrders);

    //           console.log(`🔔 Órdenes pendientes: New: ${newOrdersOnly.length}, Programmed: ${programmedOrders.length}`);

    //           if (hasNewOrderDetected) {
    //             console.log('🆕 Nueva orden detectada, notificando...');
    //             this.soundPlayed = false;
    //             this.dataSharingService.notifyNewOrders();

    //             if (this.alert_new_order_sound) {
    //               this.playNotification();
    //             }
    //           }
    //         } else {
    //           this.newOrders = [];
    //           this.dataSharingService.updateOrders([]);
    //           this.soundPlayed = false;
    //           this.notificacionSound.stopNotificationSound();
    //           console.log('🔔 No hay órdenes pendientes');
    //         }
    //       },
    //       error: (error) => {
    //         console.error('Error obteniendo órdenes:', error);
    //         this.newOrders = [];
    //         this.dataSharingService.updateOrders([]);
    //         this.notificacionSound.stopNotificationSound();
    //         this.soundPlayed = false;
    //       }
    //     });
    //   },
    //   error => {
    //     console.error('Firestore error:', error);
    //   }
    // );
  }

  getUser() {
    this.auth.getUser2().then(
        async (userLocal: any) => {
            this.user = userLocal;
            localStorage.setItem(
                'is_super',
                String(this.user.is_super)
            );

            const commerceUid =
                userLocal.business_place_uid ||
                userLocal.commerce_uid ||
                '';

            (this.user as any).commerce_uid = commerceUid;

            if (commerceUid) {
                localStorage.setItem(
                    'business_place_uid',
                    commerceUid
                );
            } else {
                localStorage.removeItem('business_place_uid');
            }

            if (
                this.user.is_admin_commerce &&
                this.user.admin_commerce &&
                this.user.admin_commerce.length > 0
            ) {
                this.admin_commerce = this.user.admin_commerce[0];

                if (this.adminCommerceSubscription) {
                    this.adminCommerceSubscription.unsubscribe();
                }

                this.adminCommerceSubscription =
                    this.firestore
                        .getOneWatcher(
                            'BusinessPlace',
                            this.admin_commerce
                        )
                        .subscribe({
                            next: (res) => {
                                this.adminCommerceData = res;
                            },
                            error: (error) => {
                            }
                        });
            }
        },
        (error) => {
        }
    );
}


  getTablesData() {
    this.tablesSubscription = this.firestore.getAll('Tables').subscribe(res => {
      if (res) {
        this.tables = res.sort((a, b) =>
          new Date(a.table_createday?.seconds * 1000).getTime() - new Date(b.table_createday?.seconds * 1000).getTime()
        );
      }
    });
  }

  getReservationsData() {
    this.tableReservationsSubscription = this.firestore.getAll('TableReservations').subscribe(res => {
      if (res) {
        this.tableReservationsList = res
          .filter(item => item.reservation_createday)
          .sort((a, b) =>
            new Date(a.reservation_date?.seconds * 1000).getTime() - new Date(b.reservation_date?.seconds * 1000).getTime()
          )
          .slice(0, 5);
      }
    });
  }

  /**
   * Logout
   * @param e - evento del click en el botón de cerrar sesión
   */
  onLogout(e: Event): void {
    e.preventDefault();

    Swal.fire({
      icon: 'info',
      text: 'Logging out, please wait a moment',
      showConfirmButton: false,
      backdrop: 'static',
      allowOutsideClick: false,
    });

    this.auth.logout()
      .then(() => {
        localStorage.clear();
        this.router.navigate(['/auth/login'])
          .then(() => Swal.close());
      })
      .catch((error) => {
        Swal.close();
      });
  }
}